import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';

export enum EFormMode {
    EDIT = 'edit',
    CREATE = 'create',
    VIEW = 'view',
    REPRESENTATION = 'representation', // full disabled, only shows values
}

export interface IReportAdditionalValues {
  reportRowIds?: string[];
  docId?: string | null;
  templateCode?: string;
  reportSectionName?: string | null;
  reportParameters?: string;
  reportRowLinks?: string;
}
export interface IRoleModelSection{
    functionName: EUserRoleFunction;
    section: string;
}
